import { isPlatform, isWeb } from '@volt-libs/foundation'
const conf = {
    env: 'staging',
    supportedLanguages: ['en', 'zh'],
    authenticationType: `${isWeb ? 'oauth' : 'iptv'}`,
    authenticationTypeTv: ['iptv'],
    isNewRelicDisabled: !isWeb,
    urls: {
        proxyUrl: 'https://waf-starhub-metadata-api-prebackend001.sh-ifs.com/v3.1',
        authUrl: 'https://uat.auth.starhub.com',
        apiUrl: 'https://api.starhubstaging.otvse.com',
        // externalDrmUrl: 'https://drm.mewatch.sg',
        externalDrmUrl: 'https://drm-stg.mewatch.sg',
        externalDrmTrackerUrl: 'https://uid.mediacorp.sg',
        gatewayApiUrl: 'https://uat.ott.starhub.com',
        gatewayTokenApiUrl: 'https://3vefupeigimoq3tmsftn54huiu0xghwp.lambda-url.ap-southeast-1.on.aws',
        optaUrl: 'https://waf-starhub-metadata-api-s001.sh-ifs.com/f309sdicsc/',
        sessionUrl: '',
        imagesUrl: '',
        licenceUrl: '',
        pinValidationUrl: '',
        recoUrl: '',
        searchUrl: '',
        reportVulnerabilityUrl: 'https://vdp.starhub.com',
        helpAndFaqUrl: 'https://www.starhub.com/tvplus-faq',
        mobileAppTermsAndConditions: 'https://corporate.starhub.com/content/dam/starhub/legal-notices-and-terms/consumer/starhub-tvplus.pdf',
        mobilePrivacyPolicy: "https://corporate.starhub.com/content/dam/starhub/legal-notices-and-terms/consumer/personal-data-protection-policy.pdf",
        emi: {
            baseUrl: 'https://waf-starhub-emi-static-api-prebackend001.sh-ifs.com',
            homePath: `3.0/{population}/${isWeb ? 1 : 3}`,
            defaultPopulation: 'staging',
        },
        signup: 'https://login.starhubgee.com.sg/sso/HubidRegisterSelected',
        forgotPassword: 'https://login.dev.starhubgee.com.sg/sso/HubidForgot',
        forgotUsername: 'https://login.dev.starhubgee.com.sg/sso/HubidForgot',
        manageDevice: '',
        store: {
            applePhone: 'https://apps.apple.com/sg/app/starhub-tv/id586220439',
            appleTablet: 'http://starhub.com/tvplus-pro-help',
            googlePhone: 'https://play.google.com/store/apps/details?id=com.starhub.itv&hl=en_GB&gl=US',
            googleTablet: 'http://starhub.com/tvplus-pro-help',
            chromeBrowser: 'https://www.google.com/chrome/',
        },
        socialMedia: {
            facebook: "https://www.facebook.com/",
            messanger: "https://www.messenger.com/",
            instagram: "https://instagram.com/",
            youtube: "https://www.youtube.com/",
            twitter: "https://twitter.com/",
        }
    },
    clientId: isWeb ? 'iFeelSmart6d5VbUddIFqe8iqopsRPrOOzlwbirombC' :'STBlWORmpY2O0OpgbR5zmUbKq7r3YjvxM6dfM35f696' ,
    clientSecret: isWeb ?'' : '8ooc7voLHiMZq18LKjfblcEmXJBRbe9AcM4WvS4LTHJ',
    allowGuest: isWeb,
    showTrailer: true,
    eplFeatures : {
        matchStatistics: true,
        matchEvents: true,
        multiCamValue: 1, // 0: Not supported, 1: Supported single view, 2: Supported multi view, here 2 views at a time,...
    },
    showRentSubscription: isWeb,
    OAuthParam: {
        grantType: 'authorization_code',
        endpoint: {
            auth: '/oauth/authorize',
            deviceCode: '/device/request',
            token: isWeb ? '/oauth/token' : '/device/token',
            refreshToken: '/oauth/token',
            fullTokenUrl: 'https://3vefupeigimoq3tmsftn54huiu0xghwp.lambda-url.ap-southeast-1.on.aws',
            fullRefreshTokenUrl: 'https://3vefupeigimoq3tmsftn54huiu0xghwp.lambda-url.ap-southeast-1.on.aws',
        },
        debugMode: true,
        forcePollingIntervalSecs: 10,
    },
    opta: {
        outletToken: '11l86zcp8kopy1hmvug79dxcb3',
        posterServerUrl: 'https://poster.starhubgo.com',
        optaReferer: 'https://ifsproxy.sh-ifs.com',
        useLegacyIds: true,
        enabled: true,
        matchEventsEnabled: true,
        matchLineUpEnabled: true,
        liveSimulatorEnabled: false,
        statsPeriodAutoRefresh: 60 * 1000, // 60000 ms | 1 min
    },
    proxyVersion: 3,
    ufinity: {
        jwt: {
            iss: 'TestAccountForHS256',
            privateKey: 'oS8ajpB6PzrfJFG+9//LKTVKOiTNzC3a2g/0Xff/Ups=',
            // This part trigger internal web service for generating the Ufinity JWT Token - Disabled and need to be moved outisde this object for better readability
            isUseJwtService: true,
            jwtServiceSecret: 'aUZlZWxTbWFydF9TdGFnaW5n',
            jwtClientId: 'iFeelSmart_Staging',
        },
        // Temporary disable due to performance issue with JWT
        disableNotifyUserLogin: true,
        disableOfferDetails: true,
        // Packs allowed to be purchased : LIGER and APPS
        enabledSubscriptionsProductTypesSTB: ['LIGER', 'APPS', 'PPV'],
        enabledSubscriptionsProductTypesOpenDevice: ['INTERNET', 'PPV'],
        oneTypeChargeProductTypes: ['PPV'],
        // enabledTvodProductTypes: ['TVOD'],
        // DEBUG MODE. to allow to login from the Username/Password page without a second screen
        debugForceTvServiceAutoSelection: false,
    },
    nagra: {
        tenantId: 'nagra',
        metadataProvider: 'GLOBAL',
        rollingBufferDuration: 24,
        fetchOnlySubscribedProducts: false,
        widevineLicenseUrl: 'https://scv23reh.anycast.nagra.com',
        SSMLicenseUrl: 'https://scv23reh-ssm.anycast.nagra.com/SCV23REH/ssm',
        fairplayLicenseUrl: 'https://scv23reh.anycast.nagra.com',
        fairplaySSMLicenseUrl: 'https://scv23reh-ssm.anycast.nagra.com/SCV23REH/ssm/v1',
        playerTenantId: 'SCV23REH',
        useTokenization: true,
    },
    voltPlayer: {
        drmConfig: {},
        mediaEngine: 'nagra',
    },
    mediacorp: {
        network: 'starhub',
        partnerId: 'JIUzI1NiJ9',
        partnerToken: '4448c697-6819-441c-8bf8-32b73f66662b',
        refreshTokenTimeoutMs: 1 * 60 * 60 * 1000, // Internal value for refreshing mediacorp access token
        kidCachingIntervalMs: 1 * 60 * 60 * 1000, // Interval for caching the KID
    },
    gfkAnalytics: {
        enable: !isWeb,
        contentId: 'Linear',
        streamId: 'StarhubTizenTV',
        mediaId: 'StarhubTizenTV',
        sdkJsonUrl:
            'https://sg-config-preproduction.sensic.net/s2s-android.json',
        url: 'https://sg-config-preproduction.sensic.net/ctv/s2s-web.js',
        media: 's2s-html5-demo',
        type: 'TV',
        device: 'SMART-TV',
        logLevel: 'debug',
    },
    broadpeak: {
        enable: true, // enable broadpeak support (need also to be activated in settings.gradle)
        adsEnable: true, // enable ads integration (need also to be activated in settings.gradle)
        analyticsAddress: 'http://202.156.10.92', // broadpeak analytics address
        nanoCDNHost: '', // nanoCDN Host needed to support multicast CDN
        broadpeakDomainNames: 'stg-ucdn.starhubgo.com', // broadpeakDomainNames
    },
    firebaseConfig: {
        enabled: true,
        apiKey: `${isWeb ? 'AIzaSyAS9v7QFMJ7WjVMrE1OWYVeJKBjiZVbjDM' : 'AIzaSyBRHNdU06_a71J6f0WM1hZlcr2AD_Reg9s'}`,
        authDomain: "starhub-ifs-uat.firebaseapp.com",
        projectId: "starhub-ifs-uat",
        storageBucket: `${isWeb ? 'starhub-ifs-uat.appspot.com' : 'starhub-ifs-uat.firebasestorage.app'}`,
        messagingSenderId: "359855094350",
        appId: `${isWeb ? '1:359855094350:web:5dd6ac3a564e9d9ce6a11f' : '1:359855094350:web:aca86ddf73dca762e6a11f'}`,
        measurementId: `${isWeb ? 'G-PK9WDYV3C2' : 'G-YKCCV7MTXT'}`
    },
    conviva: {
        enable: true,
        customerKey: 'ce72c24b6cec8e868419d5093b7822a11707ae42',
        gatewayUrl: 'https://ce72c24b6cec8e868419d5093b7822a11707ae42.ts-testonly.conviva.com',
        logLevel: 0,
        applicationName: 'webStv',
    },
    adobeAnalytics: {
        enabled: true,
        analyticsUserUrl: 'https://dpm.demdex.net/id',
        analyticsApiUrl: 'https://mediacorp.hb-api.omtrdc.net/api/v1',
        trackingServer: 'mediacorp.sc.omtrdc.net',
        reportSuit: 'mediacorp-dtm-uat',
        organisationId: 'B464317853A9C8390A490D4E@AdobeOrg',
        apiVersion: 2,
        pingPeriodMsecs: 10000,
    },
    heroSliderAutoplay : isWeb ? true : true,
    hybridHeight: isWeb ? '135px': '250px',
    showBingeWatch : true,
}

export default conf
